export const USER_PERMISSIONS_LIST = "USER_PERMISSIONS_LIST"
export const USER_PERMISSIONS_LIST_SUCCESS = "USER_PERMISSIONS_LIST_SUCCESS"
export const USER_PERMISSIONS_LIST_ERROR = "USER_PERMISSIONS_LIST_ERROR"

export const USER_PERMISSIONS_NEW = "USER_PERMISSIONS_NEW"
export const USER_PERMISSIONS_NEW_SUCCESS = "USER_PERMISSIONS_NEW_SUCCESS"
export const USER_PERMISSIONS_NEW_ERROR = "USER_PERMISSIONS_NEW_ERROR"

export const USER_PERMISSIONS_EDIT = "USER_PERMISSIONS_EDIT"

export const USER_PERMISSIONS_DELETE = "USER_PERMISSIONS_DELETE"
export const USER_PERMISSIONS_DELETE_SUCCESS = "USER_PERMISSIONS_DELETE_SUCCESS"
export const USER_PERMISSIONS_DELETE_ERROR = "USER_PERMISSIONS_DELETE_ERROR"

export const USER_PERMISSIONS_TYPES_LIST = "USER_PERMISSIONS_TYPES_LIST"
export const USER_PERMISSIONS_TYPES_LIST_SUCCESS = "USER_PERMISSIONS_TYPES_LIST_SUCCESS"
export const USER_PERMISSIONS_TYPES_LIST_ERROR = "USER_PERMISSIONS_TYPES_LIST_ERROR"